export const loadingTextForTable = "Loading... Please wait";

export const yearLabel = (year) => {
  return year ? `${year - 1}-${year.toString().slice(-2)}` : "";
};

export const divisionOptions = [
  { text: "I", value: 1 },
  { text: "II", value: 2 },
  { text: "III", value: 3 },
];
